// DisabledTooltip.js — "Function Not Available Currently" hover label
//
// Uses React.cloneElement to inject the tooltip directly onto the child element.
// No wrapper DOM node is added, so the child's CSS, sizing, and layout are
// completely unaffected.

import React from "react";
import "./disabledToolTip.css";

/**
 * @param {React.ReactElement} children - A single React element (button, div, etc.)
 * @param {string}  [label]             - Override the default tooltip text
 * @param {boolean} [disabled=true]     - Set false to suppress the tooltip entirely
 */
const DisabledTooltip = ({
  children,
  label = "Function Not Available Currently",
  disabled = true,
}) => {
  if (!disabled) return children;

  const child = React.Children.only(children);

  // Merge dt-host onto whatever className the child already has
  const existingClass = child.props.className || "";
  const mergedClass = [existingClass, "dt-host"].filter(Boolean).join(" ");

  return React.cloneElement(child, {
    className: mergedClass,
    "data-dt-label": label,
  });
};

export default DisabledTooltip;
